var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_1271)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 12.75C25.25 12.3344 25.5844 12 26 12H27.2906C28.0344 12 28.7 12.4719 28.9438 13.175L29.1969 13.9031L30.7906 13.1063C30.9281 13.0375 31.0812 13 31.2375 13H31.5C31.775 13 32 13.225 32 13.5V15.5C32 15.775 31.775 16 31.5 16H31.2375C31.0812 16 30.9281 15.9625 30.7906 15.8938L29.7 15.3469L30.625 18.0125C30.75 18.0031 30.875 18 31 18C32.3656 18 33.6031 18.5469 34.5031 19.4312C34.8 19.7219 34.8031 20.1969 34.5125 20.4906C34.2219 20.7844 33.7469 20.7906 33.4531 20.5C32.8188 19.8813 31.9563 19.5 31 19.5C29.3531 19.5 27.9688 20.6406 27.5969 22.175C27.5344 22.4375 27.5 22.7156 27.5 23H26.5H26H23C23 24.6562 21.6562 26 20 26C18.3438 26 17 24.6562 17 23H16C15.4469 23 15 22.5531 15 22V21C15 18.7906 16.7906 17 19 17H22C22.5531 17 23 17.4469 23 18V20C23 20.5531 23.4469 21 24 21H26.4156C26.9406 19.7969 27.9281 18.8375 29.1531 18.3531L27.525 13.6688C27.4906 13.5688 27.3938 13.5 27.2875 13.5H26C25.5844 13.5 25.25 13.1656 25.25 12.75ZM19 14H22C22.5531 14 23 14.4469 23 15C23 15.5531 22.5531 16 22 16H19C18.4469 16 18 15.5531 18 15C18 14.4469 18.4469 14 19 14ZM20 24.5C20.8281 24.5 21.5 23.8281 21.5 23H18.5C18.5 23.8281 19.1719 24.5 20 24.5ZM31 24.5C31.8281 24.5 32.5 23.8281 32.5 23C32.5 22.1719 31.8281 21.5 31 21.5C30.1719 21.5 29.5 22.1719 29.5 23C29.5 23.8281 30.1719 24.5 31 24.5ZM31 26C29.3438 26 28 24.6562 28 23C28 21.3438 29.3438 20 31 20C32.6562 20 34 21.3438 34 23C34 24.6562 32.6562 26 31 26Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_1271",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_1271"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoped);
export default __webpack_public_path__ + "static/media/moped.54814d3040624693842ebd09acba7cb5.svg";
export { ForwardRef as ReactComponent };